import { initializeUser } from '../reducers/userReducer'

const loginUser = async dispatch => {
  return await dispatch(initializeUser())
}

export default loginUser
